/* =========================================================
   MAP ENTRY
   ========================================================= */

   import { initMapPage } from "./map-init.js";

   initMapPage();